module.exports = __webpack_public_path__ + "img/shutterstock_144563243-cropped.b2e4a9a9.jpg";